module.exports = __webpack_public_path__ + "assets/img/vtuber-left2.46e277f9.png";